module.exports = __webpack_public_path__ + "img/dkleech.9f8dd841.png";